import { addLocale, locale } from 'primereact/api';

// Objeto de traducción, si crece mucho, moverlo a un json
const idiomaEs = {
    startsWith: 'Empieza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Es igual a',
    notEquals: 'No es igual a',
    noFilter: 'Remover filtro',
    lt: 'Menor que',
    lte: 'Menor o igual a',
    gt: 'Mayor que',
    gte: 'Mayor o igual a',
    dateIs: 'Es la fecha',
    dateIsNot: 'No es la fecha',
    dateBefore: 'Antes de',
    dateAfter: 'Después de',
    clear: 'Limpiar',
    apply: 'Aplicar',
    matchAll: 'Coincidir todo',
    matchAny: 'Coincidir cualquiera',
    addRule: 'Agregar regla',
    removeRule: 'Eliminar regla',
    accept: 'Sí',
    reject: 'No',
    choose: 'Escoger',
    upload: 'Subir',
    cancel: 'Cancelar',
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    weekHeader: 'Sem',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Débil',
    medium: 'Medio',
    strong: 'Fuerte',
    passwordPrompt: 'Escriba una contraseña',
    emptyFilterMessage: 'No se encontraron resultados',
    emptyMessage: 'No hay opciones disponibles',
    aria: {
        firstPageLabel: 'Primera página',
        lastPageLabel: 'Última página',
        previousPageLabel: 'Página anterior',
        nextPageLabel: 'Página siguiente',
        pageLabel: 'Página {page}',
        trueLabel: 'Verdadero',
        falseLabel: 'Falso',
        nullLabel: 'No seleccionado',
        star: '1 estrella',
        stars: '{star} estrellas',
        selectAll: 'Seleccionar todos',
        unselectAll: 'Deseleccionar todos',
        close: 'Cerrar',
        previous: 'Anterior',
        next: 'Siguiente',
        navigation: 'Navegación',
        scrollTop: 'Desplazarse hacia arriba',
        moveTop: 'Mover al principio',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        moveBottom: 'Mover al final',
        moveToTarget: 'Mover al objetivo',
        moveToSource: 'Mover al origen',
        moveAllToTarget: 'Mover todo al objetivo',
        moveAllToSource: 'Mover todo al origen',
        rowsPerPageLabel: 'Filas por página',
        jumpToPageDropdownLabel: 'Ir al menú de páginas',
        jumpToPageInputLabel: 'Ir a la entrada de página',
        selectRow: 'Fila seleccionada',
        unselectRow: 'Fila deseleccionada',
        expandRow: 'Fila expandida',
        collapseRow: 'Fila plegada',
        showFilterMenu: 'Mostrar menú del filtro',
        hideFilterMenu: 'Ocultar menú del filtro',
        filterOperator: 'Operador del filtro',
        filterConstraint: 'Restricción del filtro',
        editRow: 'Editar fila',
        saveEdit: 'Guardar editado',
        cancelEdit: 'Cancelar editado',
        listView: 'Vista de lista',
        gridView: 'Vista de cuadrícula',
        slide: 'Deslizar',
        slideNumber: '{slideNumber}',
        zoomImage: 'Ampliar imagen',
        zoomIn: 'Ampliar',
        zoomOut: 'Reducir',
        rotateRight: 'Girar a la derecha',
        rotateLeft: 'Girar a la izquierda'
    }
};

// Registramos el idioma (Efecto secundario al importar este archivo)
addLocale('es', idiomaEs);

// Activamos el idioma
locale('es');

// Exportamos la configuración para el Provider
export const primeConfig = {
    ripple: true,
    inputStyle: 'outlined',
    locale: 'es', // Idioma español
    hideOverlaysOnDocumentScrolling: false,
    cssTransition: true,
    autoZIndex: true,
};
